import { render, staticRenderFns } from "./AuthHead.vue?vue&type=template&id=36f7e3ed&scoped=true"
import script from "./AuthHead.vue?vue&type=script&lang=js"
export * from "./AuthHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f7e3ed",
  null
  
)

export default component.exports